module.exports = __webpack_public_path__ + "static/media/girl_writing.bcbaf961.png";